/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
const CART_PDP_MAX_QTY = 10;

function computeCartLineMaxQuantity($input) {
  const inventoryQuantity = parseInt($input.attr('data-variant-inventory'), 10) || 0;
  const policy = ($input.attr('data-variant-policy') || '').toLowerCase();
  const remainingPreorder = parseInt($input.attr('data-remaining_preorder'), 10) || 0;
  const poInventory = parseInt($input.attr('data-po-inventory'), 10) || 0;
  const currentVal = parseInt($input.val(), 10) || 1;

  let backorderQty = 0;
  if (inventoryQuantity < 0) backorderQty = Math.abs(inventoryQuantity);

  const availableQty = Math.max(0, inventoryQuantity);
  const totalPossible = availableQty + remainingPreorder;

  let maxQuantity;
  if (policy === 'continue' && inventoryQuantity <= 0) {
    if (remainingPreorder > 0) {
      maxQuantity = Math.min(totalPossible, CART_PDP_MAX_QTY);
    } else {
      maxQuantity = CART_PDP_MAX_QTY;
    }
  } else {
    maxQuantity = totalPossible;
  }

  if (maxQuantity > CART_PDP_MAX_QTY) maxQuantity = CART_PDP_MAX_QTY;

  if (maxQuantity <= 0) {
    if (policy === 'continue') {
      maxQuantity = CART_PDP_MAX_QTY;
    } else {
      maxQuantity = Math.max(0, currentVal);
    }
  }

  const effectiveMax = (maxQuantity != null && maxQuantity >= 1) ? maxQuantity : CART_PDP_MAX_QTY;
  return { maxQuantity: effectiveMax, policy, poInventory };
}

function applyCartQuantityLogic() {
  $('.cart__item-list .quantity-input').each(function () {
    const $input = $(this);
    const hasData = $input.attr('data-variant-inventory') != null && $input.attr('data-variant-policy') != null;
    let maxToSet;

    if (hasData) {
      const { maxQuantity, policy, poInventory } = computeCartLineMaxQuantity($input);
      maxToSet = maxQuantity;
      if (maxQuantity >= 1) {
        $input.attr('data-max-quantity', maxQuantity);
        if (policy === 'continue' && poInventory >= 1) {
          $input.attr('data-is-preorder', 'true');
          $input.attr('data-po-inventory', maxQuantity);
        } else {
          $input.removeAttr('data-is-preorder');
          $input.removeAttr('data-po-inventory');
        }
      } else {
        $input.removeAttr('data-max-quantity');
        $input.removeAttr('data-is-preorder');
        $input.removeAttr('data-po-inventory');
      }
    } else {
      const max = parseInt($input.attr('max'), 10);
      maxToSet = (isNaN(max) || max < 1) ? CART_PDP_MAX_QTY : Math.min(max, CART_PDP_MAX_QTY);
    }

    if (maxToSet >= 1) {
      $input.attr('max', maxToSet);
      this.setAttribute('max', maxToSet);
    }

    if (window.PXUTheme.quantityBox && window.PXUTheme.quantityBox.updateQuantityControls) {
      window.PXUTheme.quantityBox.updateQuantityControls($input);
    }
  });
}

window.PXUTheme.jsCart = {
  init: function ($section) {

    this.$section = $section;

    if ($('#cart_form .cart__item-list').length) {
      applyCartQuantityLogic();
    }

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      window.PXUTheme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

          applyCartQuantityLogic();
        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;